import { roleEntitySchema } from '#shared/projects.role.model.js';
import { userEntitySchema } from '#shared/projects.user.model.js';
import { z } from 'zod';
const contributorEntitySchema = z.object({
    user: userEntitySchema,
    role: roleEntitySchema
});
export { contributorEntitySchema };
//# sourceMappingURL=projects.contributor.model.js.map